import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function AboutMe() {
  const navigate = useNavigate();
  const [isImageExpanded, setIsImageExpanded] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const hobbyImages = [
    {
      src: "/static/images/aboutme/crappie.png"
    },
    {
      src: "/static/images/aboutme/lmb1.jpg"
    },
    {
      src: "/static/images/aboutme/smb1.png"
    },
    {
      src: "/static/images/aboutme/lmb2.png"
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % hobbyImages.length
      );
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  // Check and apply theme on component mount
  useEffect(() => {
    const isDarkMode = document.documentElement.classList.contains('dark-mode');
    const savedTheme = localStorage.getItem('theme');
    
    // If there's a saved theme preference, apply it
    if (savedTheme) {
      if (savedTheme === 'dark' && !isDarkMode) {
        document.documentElement.classList.add('dark-mode');
      } else if (savedTheme === 'light' && isDarkMode) {
        document.documentElement.classList.remove('dark-mode');
      }
    }
  }, []);

  const toggleImage = () => {
    setIsImageExpanded(!isImageExpanded);
  };

  const toggleTheme = () => {
    const isDarkMode = document.documentElement.classList.toggle('dark-mode');
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
  };

  return (
    <div className="App">
      <nav className="main-nav">
        <div className="nav-left">
          <div className="headshot-container">
            <img 
              src="/static/images/home/profile-picture.png" 
              alt="Profile" 
              className="headshot" 
              onClick={toggleImage}
            />
          </div>
          <div className="nav-logo">Robert Study</div>
        </div>
        <div className="nav-links">
          <a onClick={() => navigate('/')}>Back to Home</a>
        </div>
      </nav>

      <section className="hero-section">
        <div className="hero-content" style={{ 
          display: 'flex', 
          gap: '2rem',
          alignItems: 'flex-start',
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 2rem'
        }}>
          <div className="hero-text-content" style={{ flex: '1' }}>
          <h1>About <span className="highlight">Me</span></h1>
          <p className="hero-text">
          I've always been curious about how things work and enjoyed working with my hands. This initially led me toward mechanical engineering, but as college approached, I found myself more drawn to software because of the broad range of disciplines it offers.
          </p>
          <p className="hero-text">
          As I went through college, my interests expanded into cybersecurity and DevOps mostly out of necessity. While I was learning how to write programs in class, I realized I had little understanding of how to actually deploy them, let alone do that securely. Gaining experience with secure deployment and scalable infrastructure has helped me launch my own applications, as well as approach the design of larger enterprise systems more thoughtfully.
          </p>
          <p className="hero-text">
          More recently, I’ve been exploring how AI can improve existing systems, especially where it intersects with infrastructure, automation, and user experience. Most of my recent projects, both personal and work-related, have centered on this focus.
          </p>
          <p className="hero-text">
          Outside of work and school, I’m an avid outdoorsman with a strong passion for fishing. I spend much of my free time targeting largemouth, smallmouth, and musky between Illinois and Wisconsin.
          </p>
          </div>
          
          <div className="hobby-carousel" style={{
            flex: '1',
            position: 'relative',
            maxWidth: '500px',
            overflow: 'hidden',
            borderRadius: '12px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            marginTop: '10rem'
          }}>
            <div style={{
              position: 'relative',
              paddingTop: '130%', // Square aspect ratio
            }}>
              <img 
                src={hobbyImages[currentImageIndex].src}
                alt="Hobby"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  transition: 'opacity 0.5s ease-in-out'
                }}
              />
            </div>
          </div>
        </div>
      </section>
      
      <footer style={{
        backgroundColor: 'var(--bg-color)',
        color: 'var(--text-color)',
        padding: '1.5rem',
        textAlign: 'center',
        borderTop: '1px solid var(--accent-color)',
        marginTop: '2rem'
      }}>
        <p style={{ 
          fontSize: '0.9rem',
          opacity: '0.8'
        }}>
          © {new Date().getFullYear()} Robert Study. All rights reserved.
        </p>
      </footer>

      <button onClick={toggleTheme} className="theme-toggle">
        <span className="light-icon">Light Mode</span>
        <span className="dark-icon">Dark Mode</span>
      </button>

      {isImageExpanded && (
        <div className="modal-overlay" onClick={toggleImage}>
          <div className="modal-content">
            <img 
              src="/static/images/home/profile-picture.png"
              alt="Profile" 
              className="expanded-profile-pic"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default AboutMe; 